<template>
    <router-link :to="href" class="link-arrow-left">
        <img :src="srcSelect + '#icon-next-' + this.theme" width="8" height="14">
        {{text}}
    </router-link>
</template>

<script>
export default {
    name: 'LinkArrowLeft',
    props: ['text', 'href', 'theme'],
    data: () => {
        return {
            srcSelect: ''
        }
    },
    mounted() {
        this.srcSelect = require(`@/assets/img/icons.svg`);
    }
}
</script>

<style lang="scss">
    .link-arrow-left {
        font-size: rem(14px);
        line-height: rem(18px);
        text-decoration: underline;
        font-weight: 600;
        display: flex;
        align-items: center;
        margin-bottom: rem(40px);

        img {
            margin-right: rem(5px);
        }

        &.u-color--blue img {filter: hue-rotate(180deg)}
    }

</style>
